const hasStorage = (): boolean => typeof sessionStorage !== 'undefined';

class SessionStorageRepository {
  /**
   * Save data to session storage
   *
   * @param {string} key
   * @param {*} value
   *
   * @return SessionStorageRepository
   */
  setItem(key: string, value: any) {
    if (hasStorage()) {
      sessionStorage.setItem(key, value);
    }

    return this;
  }

  /**
   * Get item from session storage
   *
   * @param {string} key
   * @return {*|SVGPoint|SVGNumber|string|SVGTransform|SVGLength}
   */
  getItem(key: string) {
    return hasStorage() ? sessionStorage.getItem(key) : null;
  }

  /**
   *
   * @param {string} key
   * @return {*}
   *
   * @return SessionStorageRepository
   */
  removeItem(key: string) {
    if (hasStorage()) {
      sessionStorage.removeItem(key);
    }

    return this;
  }

  /**
   * Clear session storage
   *
   * @return SessionStorageRepository
   */
  clear() {
    if (hasStorage()) {
      sessionStorage.clear();
    }

    return this;
  }
}

export default SessionStorageRepository;
